import { useMemo } from "react";

import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";

import { misc } from "../../../constants/cypressIds";

const BudgetUtilizationProgressBar = ({ value, color }) => {
  const progressValue = isNaN(value) ? 0 : value > 100 ? 100 : value;
  const labelValue = useMemo(() => {
    if (isNaN(value)) {
      return "0%";
    }
    if (value > 1000) {
      return ">1000%";
    }
    return `${Math.round(value)}%`;
  }, [value]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          mr: 1,
        }}
      >
        <LinearProgress
          sx={{
            borderRadius: 1,
            "&.MuiLinearProgress-root": {
              backgroundColor: "general.divider",
            },
            "& .MuiLinearProgress-bar": {
              backgroundColor: color.bar,
            },
          }}
          variant="determinate"
          value={progressValue}
        />
      </Box>
      <Box
        sx={{
          minWidth: 35,
        }}
      >
        <Typography variant="body2" color="textSecondary" data-cy={misc.percentage}>
          {labelValue}
        </Typography>
      </Box>
    </Box>
  );
};

export default BudgetUtilizationProgressBar;
